export const INIT_SALE_EVENT = "INIT_SALE_EVENT";
export const UPDATE_SALE_EVENT = "UPDATE_SALE_EVENT";
export const UPDATE_TIMELINE = "UPDATE_TIMELINE";
export const UPDATE_PURCHASE_PROGRESS = "UPDATE_PURCHASE_PROGRESS";

// Init
export const initSaleAction = (payload) => {
    return {
        type: INIT_SALE_EVENT,
        payload: payload,
    };
};

// Update sale event when new data be updated from BE
export const updateSaleAction = (payload) => {
    return {
        type: UPDATE_SALE_EVENT,
        payload: payload,
    };
};

// Update to content to for next phrase
export const updateTimelineAction = (payload) => {
    return {
        type: UPDATE_TIMELINE,
        payload: payload,
    };
};

// Update progress during sale open
export const updatePurchaseProgressAction = ({ saleProgress }) => {
    return {
        type: UPDATE_PURCHASE_PROGRESS,
        payload: { saleProgress },
    };
};
